import slice from "./auditLogsSlice";

export default slice.reducer;
